import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetProvider[]): IGetProvider[] => {
  const dataTableData:IGetProvider[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllProvidersList = async (): Promise<IGetProvider[]> => {
  const response =  await axiosDefaultApi.get(`/api/Providers/GetProviders`);
  return convertToDataTable(response as unknown as IGetProvider[]);
};

type QueryFnType = typeof getAllProvidersList;

type UseGetAllProvidersListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllProvidersList = ({ config }: UseGetAllProvidersListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllProvidersList'],
    queryFn: () => getAllProvidersList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};